import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import * as Type from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Button from "../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import * as FinanceListStyle from "../../common/styles/FinanceListStyle";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Wrapper = styled.div<{ dark?: boolean } & SpaceProps>`
    padding: 48px 0;
    background-color: ${({ dark }) => (dark ? theme.colors.grey1 : "transparent")};

    @media ${getBreakpoint("up", "md")} {
        padding: 75px 50px;
    }

    ${FinanceListStyle.Header} {
        font-size: 1.6rem;
    }
    ${FinanceListStyle.Content} {
        dd,
        dt {
            font-size: 1.6rem;
        }
    }

    ${space};
`;

export const ActionList = styled.ul`
    margin: 35px 0;
`;

export const ActionItem = styled.li`
    display: flex;
    align-items: flex-start;
    margin-top: 20px;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${theme.colors.grey4};

    strong {
        font-family: ${theme.fonts.regular};
    }

    svg {
        min-width: 20px;
        margin-top: 8px;
        margin-right: 17px;
        color: ${theme.colors.grey7};
    }

    html[dir="rtl"] & {
        svg {
            margin-left: 17px;
            margin-right: 0;
        }
    }
`;

export const Sidebar = styled(Flex.Col)`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    background-color: ${theme.colors.lightest};

    @media ${getBreakpoint("only", "md")} {
        position: relative;
        &::before,
        &::after {
            display: block;
            position: relative;
            width: 160px; /* magic value */
            height: 100%;
            content: "";
            background-color: ${theme.colors.lightest};
        }
        &::before {
            left: -130px; /* magic value */
        }
        &::after {
            right: -130px; /* magic value */
        }
    }

    @media ${getBreakpoint("up", "lg")} {
        justify-content: flex-end;
        background-color: transparent;
    }

    html[dir="rtl"] & {
        @media ${getBreakpoint("only", "md")} {
            &::before {
                left: auto;
                right: -130px;
            }
            &::after {
                left: -130px;
                right: auto;
            }
        }
    }
`;

export const Panel = styled.div`
    width: 100%;
    padding: ${theme.spacer}px 0;
    padding-top: 0;
    background-color: ${theme.colors.lightest};

    @media ${getBreakpoint("up", "lg")} {
        width: 375px;
        padding: ${theme.spacer}px;
        border: 1px solid #e4e4e4; /* specific color */
        border-radius: 4px;
        box-shadow: 0 10px 20px ${theme.colors.grey2};
    }
`;

export const ImageWrapper = styled.div`
    max-width: 320px;
    margin-bottom: 46px;

    @media ${getBreakpoint("up", "md")} {
        max-width: none;
    }
`;

export const Title = styled(Type.H1)`
    margin-bottom: 46px;
    font-family: ${theme.fonts.regular};
    font-size: 3.4rem;
    letter-spacing: 1.3%;
    line-height: 3.5rem;
    color: ${theme.colors.dark};
`;

export const BasketTitle = styled.h2`
    margin-bottom: 32px;
    font-family: ${theme.fonts.bold};
    font-size: 2.2rem;
    line-height: 2.8rem;
    text-align: start;
    color: ${theme.colors.dark};
`;

export const Description = styled.p`
    margin-bottom: 16px;
    font-family: ${theme.fonts.book};
    font-size: 1.8rem;
    line-height: 2.4rem;
    color: ${theme.colors.grey4};
`;

export const Link = styled(Button.Link)`
    margin-bottom: 40px;
    font-size: 1.4rem;
    text-decoration: underline;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: ${theme.space[4]}px;
    row-gap: ${theme.space[3]}px;

    ${Button.ButtonPrimary},
    ${Button.ButtonWithIcon} {
        font-size: 1.6rem;
    }

    svg {
        color: ${theme.colors.red};
    }
`;
